import React, { useState, useCallback } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import classNames from 'classnames';

const navItems = [
	{ path: '/', label: 'Home' },
	{ path: '/about-me', label: 'About' },
	{ path: '/blog', label: 'Blog' },
	{ path: '/resume', label: 'Resume' },
	{ path: '/certifications', label: 'Certifications' },
	{ path: '/connect-me', label: 'Contact' },
];

const Navbar = () => {
	const [isOpen, setIsOpen] = useState(false);
	const location = useLocation();

	const isBlogRoute = useCallback(() => {
		return location.pathname.includes('/category') ||
			location.pathname.includes('/blog') ||
			location.pathname.includes('/tag');
	}, [location]);

	const toggleMenu = () => {
		setIsOpen(prev => !prev);
	};

	const closeMenuOnMobile = () => {
		if (window.innerWidth <= 1150) { console.log(window.innerWidth);
			setIsOpen(false);
		}
	};

	const navLinkClass = (path) =>
		classNames('nav-link', 'smooth-scroll', {
			active: location.pathname === path || (path === '/blog' && isBlogRoute())
		});

	const buttonClass = classNames(
		'navbar-toggler',
		'ms-auto',
		{ collapsed: !isOpen, show: isOpen }
	);

	const renderNavLinks = (onClickHandler = null) =>
		navItems.map(({ path, label }) => (
			<li key={path} className="nav-item">
				<NavLink
					to={path}
					className={() => navLinkClass(path)}
					onClick={onClickHandler}
				>
					{label}
				</NavLink>
			</li>
		));

	return (
		<>
			<button
				onClick={toggleMenu}
				className={buttonClass}
				type="button"
				data-bs-toggle="collapse"
				data-bs-target="#header-nav"
				aria-expanded={isOpen}
			>
				<span></span><span></span><span></span>
			</button>

			<div id="header-nav" className="collapse navbar-collapse justify-content-center">
				<ul className="navbar-nav">{renderNavLinks()}</ul>
			</div>

			{isOpen && (
				<div id="mobile-nav" className="collapse navbar-collapse justify-content-center">
					<ul className="navbar-nav">{renderNavLinks(closeMenuOnMobile)}</ul>
				</div>
			)}
		</>
	);
};

export default Navbar;
